import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Colors } from 'modules/theme';

const INPUT_HEIGHT = 44;
const INPUT_RADIUS = 6;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const SelectComponent = styled.select`
  border: 1px solid #e1edf3;
  background-color: ${Colors.white};
  width: 100%;
  height: ${INPUT_HEIGHT}px;
  box-sizing: border-box;
  border-radius: ${props => props.borderRadius || INPUT_RADIUS}px;
  font-size: ${props => props.fontSize || 18}px;
  line-height: 17px;
  color: ${Colors.gray};
  padding: 0 15px;
  outline-style: none;
  line-height: 30px;
  ::placeholder {
    font-size: ${props => props.fontSize || 18}px;
    color: ${props => props.color || Colors.gray};
  }

  -webkit-appearance: none;
  -moz-appearance: none;

  border-color: ${props => (props.hasError ? Colors.red : props.borderColor || Colors.gray2)};

  ::option {
    display: flex;
    white-space: pre;
    min-height: 20px;
  }
`;

const Icon = styled.i`
  position: absolute;
  top: 50%;
  right: 18px;
  transform: translateY(-50%);
  color: ${Colors.blue};
  font-size: 12px;
  pointer-events: none;
`;

const Select = props => {
  const { placeholder, options } = props;

  return (
    <Container>
      <SelectComponent {...props} placeholder={placeholder}>
        <option value="" hidden>
          {placeholder || 'Options'}
        </option>
        {options.map(({ label, value }, key) => (
          <option value={value} key={key}>
            {label}
          </option>
        ))}
      </SelectComponent>
      <Icon className="fas fa-chevron-down" />
    </Container>
  );
};

Select.propTypes = {
  options: PropTypes.array,
  placeholder: PropTypes.string,
};

Select.defaultProps = {
  options: [],
};

export default Select;
